// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { doesNotHaveExpand, get, patch } from "@insite/client-framework/Services/ApiService";
import { UpdateShipToApiParameter } from "@insite/client-framework/Services/CustomersService";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

const billTosUrl = "/api/v1/billtos";

export async function deleteShipTo(parameter: UpdateShipToApiParameter) {
    const shipToModel = await patch<ShipToModel>(
        `${billTosUrl}/${parameter.billToId}/shiptos/${parameter.shipTo.id}?Active=false`,
        parameter.shipTo,
    );
    return shipToModel;
}
